/**
 * Phase E — billing API client wrappers.
 *
 * Three endpoints. Auth is provided by the existing `apiClient` axios
 * interceptor.
 */
import { apiClient } from "./client";

/**
 * Start a Stripe Checkout session. Returns `{checkout_url, session_id}`.
 * Caller is responsible for the redirect:
 *   const { checkout_url } = await createCheckoutSession();
 *   window.location.href = checkout_url;
 */
export async function createCheckoutSession() {
  const { data } = await apiClient.post("/billing/create-checkout-session");
  return data;
}

/**
 * Open the Stripe Customer Portal so the user can change card / cancel.
 * Returns `{portal_url}`. Caller redirects.
 */
export async function createPortalSession() {
  const { data } = await apiClient.post("/billing/create-portal-session");
  return data;
}

/**
 * Phase 1.2 — Unified subscription read endpoint.
 *
 * GET /api/billing/me returns a `SubscriptionState`:
 *   {
 *     is_pro: boolean,
 *     tier: "pro" | "free",
 *     managed_by: "apple" | "stripe" | "trial" | "none",
 *     current_period_end: ISO8601 | null,
 *     auto_renew_status: boolean | null,
 *     is_trial: boolean,
 *     source_product_id: string | null
 *   }
 *
 * Used by the ProfilePage MembershipSection to render the right
 * variant (apple shows the App Store deeplink, stripe shows the
 * customer-portal button, etc.).
 */
export async function getBillingMe() {
  const { data } = await apiClient.get("/billing/me");
  return data;
}
